import clsx from 'classnames';
import { Children, useEffect, useRef } from 'react';
import CloseIcon from 'icons/lib/close.svg';

import styles from './FilterPill.module.scss';
import { FilterPillProps } from './types';
import { Button } from 'ui';

export function FilterPill({
	children,
	className,
	icon,
	isBold = true,
	label,
	type = 'normal',
	onPress,
	onClear,
}: FilterPillProps) {
	const hasChildren = Children.count(children) > 0;
	const LabelComponent = hasChildren ? 'span' : 'strong';
	const containerRef = useRef<HTMLDivElement>(null);
	const labelRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!containerRef.current) {
			return;
		}

		if (Children.count(children) < 1) {
			containerRef.current.style.minWidth = '';

			return;
		}

		if (!labelRef.current) {
			return;
		}

		containerRef.current.style.minWidth = onClear
			? `${labelRef.current.offsetWidth + 55}px`
			: `${labelRef.current.offsetWidth + 6}px`;
	}, [Children.count(children), labelRef?.current?.offsetWidth]);

	return (
		<div
			className={clsx(
				styles.filterPill__wrapper,
				type === 'normal'
					? styles['filterPill__wrapper--normal']
					: styles['filterPill__wrapper--error'],
				className,
				{
					[styles['filterPill__wrapper--hasChildren']]: hasChildren && isBold,
					[styles['filterPill__wrapper--notBold']]: hasChildren && !isBold,
				}
			)}
			ref={containerRef}
		>
			{hasChildren && (
				<div className={styles.filterPill__labelWrapper} onClick={onPress}>
					<LabelComponent className={styles.filterPill__label} ref={labelRef}>
						{label}
					</LabelComponent>
				</div>
			)}
			<div className={styles.filterPill__contentWrapper} onClick={onPress}>
				{!!icon && <div className={styles.filterPill__icon}>{icon}</div>}
				<div className={styles.filterPill__content}>{hasChildren ? children : label}</div>
			</div>
			{hasChildren && onClear && (
				<div className={styles.filterPill__clearButton}>
					<Button size="icon" variant="iconButton" onPress={onClear}>
						<CloseIcon />
					</Button>
				</div>
			)}
		</div>
	);
}
